export default "__VITE_ASSET__DQzmKZAy__"